var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('span',[_c('v-tooltip',{attrs:{"open-delay":"100","top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_vm._v(" "+_vm._s(_vm.text)+" ")])]}}],null,false,4206222767)},[_c('span',[_vm._v(" "+_vm._s(_vm.dateTime.toFormat('ff'))+" ")])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }